import { render } from "./RolePage.vue?vue&type=template&id=2f2517db&scoped=true"
import script from "./RolePage.vue?vue&type=script&lang=js"
export * from "./RolePage.vue?vue&type=script&lang=js"

import "./RolePage.vue?vue&type=style&index=0&id=2f2517db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2517db"]])

export default __exports__